import { guides } from "@/mocks/home";

export default function AntiLostGuide() {
  return (
    <section id="guide" className="bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="reveal max-w-2xl">
          <span className="font-label text-[11px] tracking-[0.3em] text-primary-600">
            NEVER GET LOST
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[42px]">
            黑料总站防走丢指南
          </h2>
          <p className="mt-5 text-sm leading-8 text-foreground-700">
            四步做完，之后再遇到地址失效也不必慌张。这套做法同样适用于所有需要频繁更换入口的站点。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {guides.map((item) => (
            <div
              key={item.id}
              className="reveal relative rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <span className="absolute right-6 top-6 font-heading text-4xl font-black text-background-300">
                {item.step.replace("第", "").replace("步", "")}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <p className="mt-6 font-label text-[11px] tracking-[0.28em] text-foreground-500">
                {item.step}
              </p>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-12 flex flex-col items-start gap-6 rounded-lg border border-background-300 bg-background-100 p-6 md:flex-row md:items-center md:justify-between md:p-8">
          <div className="flex items-start gap-4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className="ri-shield-check-line text-2xl" />
            </span>
            <div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">
                安全提醒：只用本页展示过的地址
              </h3>
              <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-700">
                第三方短链、陌生群聊中流传的链接都可能指向仿冒页面，请以本发布页的通道列表为准。
              </p>
            </div>
          </div>
          <button
            type="button"
            className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600"
          >
            <i className="ri-question-answer-line" />
            查看常见问题
          </button>
        </div>
      </div>
    </section>
  );
}